module.exports = __webpack_public_path__ + "static/img/case3.907bb3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case3.png
// module id = 31
// module chunks = 0